import type { Question, QuestionType } from "@/types/question";
import createQuestion from "./createQuestion";

export default function setQuestionType(
  question: Question,
  type: QuestionType,
) {
  const { cfg } = createQuestion(type);
  const prevCfgProperties = Object.keys(question.cfg);
  const newCfgProperties = Object.keys(cfg);

  // Copies values from old cfg to new cfg,
  // but only those that have existing properties in new cfg
  for (const key of prevCfgProperties) {
    if (newCfgProperties.includes(key)) {
      (cfg as Record<string, unknown>)[key] = (
        question.cfg as Record<string, unknown>
      )[key];
    }
  }
  return {
    ...question,
    type,
    cfg,
  };
}
